import type { Camera, Raycaster } from 'three'
import { Vector2 } from 'three'

const ndcScratch = new Vector2()

/**
 * Proyecta coordenadas de pantalla al raycaster usando el rect del canvas.
 * Evita depender del `pointer` de R3F cuando el arrastre arranca desde listeners globales.
 */
export function setRaycasterFromClient(
  raycaster: Raycaster,
  camera: Camera,
  clientX: number,
  clientY: number,
  canvas: HTMLElement,
): void {
  const rect = canvas.getBoundingClientRect()
  if (rect.width <= 0 || rect.height <= 0) return

  ndcScratch.set(
    ((clientX - rect.left) / rect.width) * 2 - 1,
    -((clientY - rect.top) / rect.height) * 2 + 1,
  )
  raycaster.setFromCamera(ndcScratch, camera)
}
